import './main';

document.addEventListener('DOMContentLoaded', function () {
  const formContainer = document.querySelector('.case-studies__form-container');
  const blockquote = document.querySelector('.case-studies-content blockquote.wp-block-quote') ?? document.querySelector('.case-studies-content section.gallery') ?? document.querySelector('.case-studies-content section.section-download');

  if (!formContainer || !blockquote) return;

  function updateFormHeight() {
    const containerRect = formContainer.getBoundingClientRect();
    const blockquoteRect = blockquote.getBoundingClientRect();

    // Odległość od górnej krawędzi kontenera do blockquote w widoku
    const maxHeight = blockquoteRect.top - containerRect.top - 100; // 16px marginesu

    // Tylko jeśli blockquote jest poniżej kontenera
    if (maxHeight > 0) {
      formContainer.style.height = maxHeight + 'px';
    } else {
      formContainer.style.height = '0px';
    }
  }

  window.addEventListener('resize', updateFormHeight);
  window.addEventListener('scroll', updateFormHeight);
  updateFormHeight();
});